import Strings from "@/shared/utils/Strings.constants";
import { UIUtils } from "@/shared/utils/UIUtils";
import React from "react";

const ACHPaymentNotice = () => {
    const phone = UIUtils.formatPhone(Strings.PTZ_US.PHONE_NUMBER);
    return (
        <div className="text-center text-xs text-content-primary lg:text-left">
            To pay with Automated Clearing House (ACH), please contact our customer service at{" "}
            <a href={`tel:${UIUtils.formatPhone(Strings.PTZ_US.PHONE_NUMBER)}`} className="whitespace-nowrap underline">
                {phone}
            </a>
        </div>
    );
};

export default ACHPaymentNotice;
